/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Success_ToastInputs */

const en_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merging Event Groups Complete`)
};

const fr_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusion des groupes d'evenements terminee`)
};

const de_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführung der Ereignisgruppen abgeschlossen`)
};

const it_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unione gruppi eventi completata`)
};

const ru_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение групп событий завершено.`)
};

const es_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusión de grupos de eventos completada`)
};

const zh_cn2_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并事件组完成`)
};

const ja_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループの統合が完了しました`)
};

const hi_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूहों का विलय पूरा हुआ`)
};

const pt_pt2_translation_merge_success_toast = /** @type {(inputs: Translation_Merge_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusão de grupos de eventos concluída`)
};

/**
* | output |
* | --- |
* | "Merging Event Groups Complete" |
*
* @param {Translation_Merge_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_success_toast = /** @type {((inputs?: Translation_Merge_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_success_toast(inputs)
	if (locale === "de") return de_translation_merge_success_toast(inputs)
	if (locale === "it") return it_translation_merge_success_toast(inputs)
	if (locale === "ru") return ru_translation_merge_success_toast(inputs)
	if (locale === "es") return es_translation_merge_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_success_toast(inputs)
	if (locale === "ja") return ja_translation_merge_success_toast(inputs)
	if (locale === "hi") return hi_translation_merge_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_success_toast(inputs)
	return en_translation_merge_success_toast(inputs)
});